import React from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import PropTypes from "prop-types";
import { getDate } from "../extension/dateConvert";

const CustomDatePicker = ({defaultValue,name,placeholder, onChange}) => {
    const getSelectedDate = (e) => {
      const SelectedDate = getDate(e);
      if (onChange) {
        onChange(SelectedDate);
      }
    }
    return (
        <DatePicker
            mapDays={({ date }) => {
                let props = {}
                let isWeekend = date.weekDay.index === (6)

                if (isWeekend) props.className = "highlight highlight-red"

                return props
            }}
            portal={true}
            value={defaultValue}
            name={name}
            onChange={getSelectedDate}
            className={"w-full"}
            isDismissable={false}
            placeholder={placeholder}
            shouldCloseOnOverlayClick={false}
            inputClass={"w-full !border text-start !border-gray-300 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100 focus:!border-blue-400 !outline-0 focus:ring-blue-900/10 text-xs p-2 py-2 rounded-md"}
            calendar={persian}

            locale={persian_fa}/>
    );
};

CustomDatePicker.propTypes = {
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

CustomDatePicker.defaultProps = {
  defaultValue: "",
  name: "",
  placeholder: "",
  onChange: () => {},
};

export default CustomDatePicker;